import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Inject, Injectable, InjectionToken, Optional } from "@angular/core";
import { Observable } from "rxjs";
import {  UserProfile } from "../web-api-client";
import { User } from "../modules/admin/users/users.component";
import { UserModel } from "../models/user.model";

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
  providedIn: 'root'
})
export class EmployeeService  {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
      this.http = http;
      this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  getCurrentUser():Observable<UserProfile>{

    return this.http.get<UserProfile>(`${this.baseUrl}api/user/current`);
  }

  getAllUsers():Observable<User[]>{
    return this.http.get<User[]>(`${this.baseUrl}api/user/all`);
  }
  createUser(user: UserModel): Observable<UserModel>{

    let data = JSON.stringify(user);
    return this.http.post<UserModel>(`${this.baseUrl}api/user/create`, data);
  }



}
